import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const CasinoRegister = lazyRouteComponent(() => import('../pages/casino-register'))

export const casinoRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/casino-register',
  component: CasinoRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
